<template>
  <nav class="app-menu">
    <div class="menu-inner">
      <a class="menu-brand" :href="homeHref" @click="$emit('external-navigate', $event)">
        <img :src="logoUrl" alt="KomDat Logo" class="menu-logo">
      </a>
      <button
        class="menu-toggler"
        type="button"
        :aria-expanded="menuOpen ? 'true' : 'false'"
        aria-label="Navigation umschalten"
        @click="menuOpen = !menuOpen"
      >
        <span class="menu-toggler-icon"></span>
      </button>
      <ul class="menu-nav" :class="{ open: menuOpen }">
        <li v-for="link in links" :key="link.text" class="menu-item">
          <a
            :href="link.href"
            class="menu-link"
            :class="{ active: link.route === route }"
            :aria-current="link.route === route ? 'page' : null"
            @click="onLinkClick(link, $event)"
          >{{ link.text }}</a>
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
import logoUrl from '../assets/KomDat_Logo.svg'

export default {
  name: 'AppMenu',
  props: {
    route: {
      type: String,
      default: '/'
    }
  },
  emits: ['external-navigate'],
  methods: {
    onLinkClick(link, event) {
      this.menuOpen = false
      if (!link.route) {
        this.$emit('external-navigate', event)
      }
    }
  },
  data() {
    return {
      logoUrl,
      menuOpen: false,
      homeHref: 'https://komdat.iosb.fraunhofer.de',
      links: [
        { text: 'Startseite', href: '#/', route: '/' },
        { text: 'Grapheditor', href: '#/editor', route: '/editor' },
        { text: 'Quickstart & FAQ', href: '#/quickstart', route: '/quickstart' },
        { text: 'Über das Projekt', href: '#/about', route: '/about' }
      ]
    }
  }
}
</script>

<style scoped>
.app-menu {
  background: #f8f9fa;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075);
  position: relative;
  z-index: 100;
}

.menu-inner {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;
  padding: 0.5rem 0.75rem;
}

.menu-brand {
  display: inline-block;
  margin-right: 1rem;
}

.menu-logo {
  height: 80px;
  width: auto;
  display: block;
}

.menu-toggler {
  display: none;
  background: transparent;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.375rem;
  padding: 0.25rem 0.75rem;
  cursor: pointer;
}

.menu-toggler-icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  vertical-align: middle;
  background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 30 30'%3e%3cpath stroke='rgba%2833, 37, 41, 0.75%29' stroke-linecap='round' stroke-miterlimit='10' stroke-width='2' d='M4 7h22M4 15h22M4 23h22'/%3e%3c/svg%3e");
  background-repeat: no-repeat;
  background-position: center;
  background-size: 100%;
}

.menu-nav {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  list-style: none;
  margin: 0;
  margin-right: auto;
  padding: 0;
}

.menu-link {
  display: block;
  color: #000;
  text-decoration: none;
  transition: background-color 0.2s, color 0.2s;
  border-radius: 0.5rem;
  padding: 0.75rem 1rem;
  margin: 0.25rem 0.5rem;
  font-weight: 500;
}

.menu-link:hover {
  background-color: #ec632b;
  color: white;
  text-decoration: none;
}

.menu-link.active {
  background-color: #ec632b;
  color: white;
  font-weight: 600;
}

@media (max-width: 991.98px) {
  .menu-toggler {
    display: inline-block;
  }

  .menu-nav {
    display: none;
    flex-basis: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .menu-nav.open {
    display: flex;
  }
}
</style>
